import React from "react";
import PropTypes from "prop-types";
import Modal from "../modal";
import get from "lodash/get";
import map from "lodash/map";

class UpdatePaymentModal extends React.Component {
  render() {
    const {
      countries: countryOptions,
      activeUser,
      getCountryName,
    } = this.context.locals;
    return (
      <form
        action="/actions/billing/update/source"
        id="form-change-card"
        method="POST"
        data-noreset
      >
        <Modal width="600px">
          <div className="head">
            <h2 className="alt">Update Payment Details</h2>
          </div>

          <div className="body">
            <div className="columns">
              <div className="column" data-col="1/1">
                <div className="label">Credit Card Number</div>
                <input
                  required
                  type="text"
                  name="source[number]"
                  className="text-input fs-hide"
                  placeholder="Credit Card Number"
                />
              </div>

              <div className="column" data-col="1/4">
                <div className="label">Expiry</div>
                <input
                  required
                  type="text"
                  name="source[exp]"
                  className="text-input fs-hide"
                  placeholder="MM/YY"
                />
              </div>

              <div className="column" data-col="1/4">
                <div className="label">Security&nbsp;Code</div>
                <input
                  required
                  type="text"
                  name="source[cvc]"
                  className="text-input fs-hide"
                  placeholder="CVC"
                />
              </div>

              <div className="column" data-col="1/1">
                <div className="label">Address</div>
                <input
                  className="text-input"
                  type="text"
                  name="source[address_line1]"
                  style={{ marginBottom: "20px" }}
                />
              </div>

              <div className="column" data-col="3/4">
                <div className="label">City</div>
                <input
                  className="text-input"
                  type="text"
                  name="source[address_city"
                />
              </div>

              <div className="column" data-col="1/4">
                <div className="label">Postal Code</div>
                <input
                  className="text-input"
                  type="text"
                  name="source[address_zip]"
                />
              </div>

              <div className="column" data-col="1/1">
                <div className="label">Country</div>
                <select
                  required
                  name="source[address_country]"
                  className="select-input"
                  defaultValue={get(activeUser, "country", "")}
                >
                  <option hidden disabled value="">
                    Location
                  </option>
                  {map(countryOptions, (code) => {
                    return (
                      <option key={code} value={code}>
                        {getCountryName(code)}
                      </option>
                    );
                  })}
                </select>
              </div>

              <hr />
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/2">
                <button className="button-input" type="submit">
                  Save Changes
                </button>
              </div>

              <div className="column mobile-hidden" data-col="1/2">
                <a className="cancel" href="/actions/refresh?modal=">
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

UpdatePaymentModal.contextTypes = { locals: PropTypes.object };

export default UpdatePaymentModal;
